import type { GetAdminRequestsVariables } from '../../graphql/types/admin_dashboard';

export type RequestTypeFilter = 'all' | 'holiday' | 'overtime';
export type RequestStatusFilter = 'all' | 'approved' | 'rejected';

export type RequestFilters = {
  from: string; // YYYY-MM-DD, '' = no limit
  to: string; // YYYY-MM-DD, '' = no limit
  type: RequestTypeFilter;
  status: RequestStatusFilter; // only applies to "Frühere Anträge"
  userId: string; // '' = all users
};

// Preset passed in when another page opens the Anträge tab (e.g. from Monatsabschluss)
export type RequestsPreset = Partial<RequestFilters>;

export const EMPTY_REQUEST_FILTERS: RequestFilters = {
  from: '',
  to: '',
  type: 'all',
  status: 'all',
  userId: '',
};

export const countActiveFilters = (filters: RequestFilters) =>
  [filters.from || filters.to, filters.type !== 'all', filters.status !== 'all', filters.userId].filter(Boolean)
    .length;

// filters as getAdminRequests variables (null = ignored by the backend)
export const toRequestVariables = (filters: RequestFilters): GetAdminRequestsVariables => ({
  from: filters.from || null,
  to: filters.to || null,
  type: filters.type === 'all' ? null : filters.type,
  approvalStatus: filters.status === 'approved' ? 1 : filters.status === 'rejected' ? 2 : null,
  user_id: filters.userId || null,
});

// first day of the month after month/year (month 1–12), as YYYY-MM-DD
export const firstDayOfNextMonth = (month: number, year: number) => {
  const next = new Date(year, month, 1);
  return `${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, '0')}-01`;
};

export const REQUEST_TYPE_LABELS: Record<RequestTypeFilter, string> = {
  all: 'Alle',
  holiday: 'Urlaub',
  overtime: 'Überstundenabbau',
};

export const REQUEST_STATUS_LABELS: Record<RequestStatusFilter, string> = {
  all: 'Alle',
  approved: 'Genehmigt',
  rejected: 'Abgelehnt',
};

export const formatDayMonthYear = (date: string) => {
  const [year, month, day] = date.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('de-DE');
};
